/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseAmazonItems
 */
export interface ResponseAmazonItems {
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    actualShippingNum?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    amazonActualShippingNum?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    amazonArriveNum?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    amazonItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItems
     */
    amazonItemName?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    amazonSetNum?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    amazonShippingNum?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    amazonSumNum?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    arriveNum?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItems
     */
    asin?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    baseId?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    createdUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItems
     */
    deliveryUnit?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    destructionNum?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItems
     */
    expiryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItems
     */
    fnskuCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItems
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItems
     */
    inputDate?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    itemId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItems
     */
    itemName?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItems
     */
    janCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItems
     */
    memo?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItems
     */
    parentExpiryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItems
     */
    planName?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    returnNum?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    setNum?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    shippingNum?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItems
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    statusId?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    stickerNum?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItems
     */
    storageLocation?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    sumNum?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItems
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItems
     */
    userName?: string;
}

/**
 * Check if a given object implements the ResponseAmazonItems interface.
 */
export function instanceOfResponseAmazonItems(value: object): value is ResponseAmazonItems {
    return true;
}

export function ResponseAmazonItemsFromJSON(json: any): ResponseAmazonItems {
    return ResponseAmazonItemsFromJSONTyped(json, false);
}

export function ResponseAmazonItemsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAmazonItems {
    if (json == null) {
        return json;
    }
    return {
        
        'actualShippingNum': json['actual_shipping_num'] == null ? undefined : json['actual_shipping_num'],
        'amazonActualShippingNum': json['amazon_actual_shipping_num'] == null ? undefined : json['amazon_actual_shipping_num'],
        'amazonArriveNum': json['amazon_arrive_num'] == null ? undefined : json['amazon_arrive_num'],
        'amazonItemId': json['amazon_item_id'] == null ? undefined : json['amazon_item_id'],
        'amazonItemName': json['amazon_item_name'] == null ? undefined : json['amazon_item_name'],
        'amazonSetNum': json['amazon_set_num'] == null ? undefined : json['amazon_set_num'],
        'amazonShippingNum': json['amazon_shipping_num'] == null ? undefined : json['amazon_shipping_num'],
        'amazonSumNum': json['amazon_sum_num'] == null ? undefined : json['amazon_sum_num'],
        'arriveNum': json['arrive_num'] == null ? undefined : json['arrive_num'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'baseId': json['base_id'] == null ? undefined : json['base_id'],
        'createdUserId': json['created_user_id'] == null ? undefined : json['created_user_id'],
        'deliveryUnit': json['delivery_unit'] == null ? undefined : json['delivery_unit'],
        'destructionNum': json['destruction_num'] == null ? undefined : json['destruction_num'],
        'expiryDate': json['expiry_date'] == null ? undefined : json['expiry_date'],
        'fnskuCode': json['fnsku_code'] == null ? undefined : json['fnsku_code'],
        'imageUrl': json['image_url'] == null ? undefined : json['image_url'],
        'inputDate': json['input_date'] == null ? undefined : json['input_date'],
        'itemId': json['item_id'] == null ? undefined : json['item_id'],
        'itemName': json['item_name'] == null ? undefined : json['item_name'],
        'janCode': json['jan_code'] == null ? undefined : json['jan_code'],
        'memo': json['memo'] == null ? undefined : json['memo'],
        'parentExpiryDate': json['parent_expiry_date'] == null ? undefined : json['parent_expiry_date'],
        'planName': json['plan_name'] == null ? undefined : json['plan_name'],
        'returnNum': json['return_num'] == null ? undefined : json['return_num'],
        'setNum': json['set_num'] == null ? undefined : json['set_num'],
        'shippingNum': json['shipping_num'] == null ? undefined : json['shipping_num'],
        'sku': json['sku'] == null ? undefined : json['sku'],
        'statusId': json['status_id'] == null ? undefined : json['status_id'],
        'stickerNum': json['sticker_num'] == null ? undefined : json['sticker_num'],
        'storageLocation': json['storage_location'] == null ? undefined : json['storage_location'],
        'sumNum': json['sum_num'] == null ? undefined : json['sum_num'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'userName': json['user_name'] == null ? undefined : json['user_name'],
    };
}

export function ResponseAmazonItemsToJSON(json: any): ResponseAmazonItems {
    return ResponseAmazonItemsToJSONTyped(json, false);
}

export function ResponseAmazonItemsToJSONTyped(value?: ResponseAmazonItems | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actual_shipping_num': value['actualShippingNum'],
        'amazon_actual_shipping_num': value['amazonActualShippingNum'],
        'amazon_arrive_num': value['amazonArriveNum'],
        'amazon_item_id': value['amazonItemId'],
        'amazon_item_name': value['amazonItemName'],
        'amazon_set_num': value['amazonSetNum'],
        'amazon_shipping_num': value['amazonShippingNum'],
        'amazon_sum_num': value['amazonSumNum'],
        'arrive_num': value['arriveNum'],
        'asin': value['asin'],
        'base_id': value['baseId'],
        'created_user_id': value['createdUserId'],
        'delivery_unit': value['deliveryUnit'],
        'destruction_num': value['destructionNum'],
        'expiry_date': value['expiryDate'],
        'fnsku_code': value['fnskuCode'],
        'image_url': value['imageUrl'],
        'input_date': value['inputDate'],
        'item_id': value['itemId'],
        'item_name': value['itemName'],
        'jan_code': value['janCode'],
        'memo': value['memo'],
        'parent_expiry_date': value['parentExpiryDate'],
        'plan_name': value['planName'],
        'return_num': value['returnNum'],
        'set_num': value['setNum'],
        'shipping_num': value['shippingNum'],
        'sku': value['sku'],
        'status_id': value['statusId'],
        'sticker_num': value['stickerNum'],
        'storage_location': value['storageLocation'],
        'sum_num': value['sumNum'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
        'user_name': value['userName'],
    };
}

